import type { Resources } from './en';

const pt: Resources = {
  nav: {
    songs: 'Músicas',
    artists: 'Artistas',
    search: 'Buscar',
    generator: 'Gerador',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    signOut: 'Sair',
  },
  home: {
    heroTitle: 'Descubra as histórias por trás das letras das suas músicas favoritas',
    heroSubtitle: 'Analisamos o significado das letras das suas músicas favoritas',
    searchPlaceholder: 'Busque qualquer música ou significado…',
    trendingLabel: 'EM ALTA',
    latestLabel: 'RECENTES',
    allArtists: 'Todos os artistas',
  },
  search: {
    title: 'Resultados',
    empty: 'Nenhuma música encontrada.',
    placeholder: 'Busque qualquer música ou significado…',
  },
  songCard: {
    by: 'por',
  },
  footer: {
    updates: 'Atualizações',
    about: 'Sobre',
    contact: 'Contato',
    terms: 'Termos e Condições',
    privacy: 'Privacidade e Cookies',
    copyright: '© {{years}}',
    language: 'Idioma',
  },
  languages: {
    en: 'Inglês',
    es: 'Espanhol',
    pt: 'Português',
  },
  songDetail: {
    pageSubtitle: 'Letras, significado e referência da música para criar uma faixa original no MixGenie.',
    moreByArtist: 'Mais de {{artist}}',
    meaningHeading: 'Significado',
    lyricsHeading: 'Letras',
    lyricsOriginalTab: 'Original',
    lyricsAlreadyIn: 'Esta letra já está em {{language}}.',
    noTranslationYet: 'Ainda não há tradução em {{language}}.',
    noMeaningYet: 'Ainda não há significado em {{language}}.',
    getNow: 'Obter agora',
    translatingTo: 'Traduzindo para {{language}}…',
    generatingMeaning: 'Gerando significado em {{language}}…',
    noLyricsForMeaning: 'Não encontramos a letra, então não foi possível gerar o significado.',
    noLyricsFound: 'Letra não encontrada para esta música.',
    translationUnavailable: 'Tradução indisponível sem letra.',
    songNotFound: 'Música não encontrada',
    loadingSong: 'Carregando música…',
    fetchingLyrics: 'Buscando letra…',
    generatingMeaningShort: 'Gerando significado…',
    findingCoverArt: 'Procurando capa…',
    almostReady: 'Quase pronto…',
  },
  createSimilar: {
    heading: 'Crie uma música parecida com esta',
    description: 'Cadastre-se em uma assinatura gratuita do MixGenie com {{credits}} créditos e gere uma música original inspirada em {{title}} de {{artist}}.',
    descriptionAuthed: 'Gere uma música original inspirada em {{title}} de {{artist}}.',
    cta: 'Começar com esta referência',
    ctaAuthed: 'Começar com esta referência',
  },
  streamingLinks: {
    heading: 'Ouvir em',
  },
};

export default pt;
